import * as _ from "lodash";
import {UserRegisterForm as Validator} from '../../utils/validators';

interface Action {
    payload: any,
    type: string,
    field: string,
    apiError?: string | boolean,
    value?: any,
    validate: boolean
}

interface Form {
    valid: boolean,
    changed: boolean
    data: {
        [key: string]: {
            required: boolean,
            added: boolean,
            value: any,
            error: any,
            errTypes?: any
            dirty?: boolean
        },
    }
}

interface Errors {
    [key: string]: string
}

const initialState: Form = {
    valid: false,
    data: {
        fullName: {
            required: true,
            added: false,
            value: null,
            error: null,
            dirty: false
        },
        email: {
            required: true,
            added: false,
            value: null,
            error: null,
            dirty: false
        },
        firstName: {
            required: false,
            added: false,
            value: null,
            error: null,
        },
        lastName: {
            required: false,
            added: false,
            value: null,
            error: null
        },
        password: {
            required: true,
            added: false,
            value: null,
            error: null,
            dirty: false,
            errTypes: {
                u: false,
                l: false,
                n: false,
                min: false
            }
        },
        phone: {
            required: true,
            added: false,
            value: null,
            error: null,
            dirty: false
        },
        businessName: {
            required: false,
            added: false,
            value: null,
            error: null
        },
    },
    changed: false,
};

const baseState = _.cloneDeep(initialState);

const UserRegisterForm = (state = initialState, action: Action) => {
    switch (action.type) {
        case 'USER_REGISTER_FORM_ADD_CHANGE':
            return Validator({...state.data}, action);
        case 'RESET_REGISTER_FORM':
            return _.cloneDeep(baseState);
        default:
            return state;
    }
};

export default UserRegisterForm;
